// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wireless":"wireless-3VFugvFS","link":"link-3_rfZ5Rr","list":"list-3SkFY36O clearfix"};